import { useSetRecoilState } from "recoil";
import { ocNotificationState } from "states";

export const useNotification = () => {
  const setOpenMessage = useSetRecoilState(ocNotificationState);
  return setOpenMessage;
};

export default useNotification;
